export const DATE_WIDTH = 8 * 15;
export const TIME_WIDTH = 8 * 13.5;
